<template>
  <div>
    <div class="row" v-if="menuprincipal">
      <div class="col-6 mt-3 d-flex" v-bind:key="currentMenu.name" v-for="currentMenu in modules" v-if="currentMenu.show_in_hh"
        @click="seleccionarMenu(currentMenu)">
        <div class="buttons-group">
          <button class="c-button c-button--lg">
            <div class="icon-w" style="font-size: 2.5em">
              <div :class="currentMenu.icon"></div>
            </div>
            <span style="font-size: 1.3em;" v-html="currentMenu.description"> </span>
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-if="!menuprincipal">
      <div class="ae-side-menu" style="min-width: 100%">
        <div class="aem-head">
          <!-- Mismo estilo que "Ver todos los Requerimientos" -->
          <button type="button" @click="regresar" class="btn btn-sm btn-info d-inline-flex align-items-center">
            <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
            <span class="ml-1">Regresar</span>
          </button>
        </div>

        <div class="row" v-for="currentMenu in modules" v-bind:key="'su2b_' + currentMenu.name"
          v-if="sub_menu_name == currentMenu.name && currentMenu.show_in_hh">
          <div class="col-6 mt-3 d-flex" v-bind:key="currentSubItem.name" v-for="currentSubItem in currentMenu.items"
            v-if="currentSubItem.show_in_hh">
            <div class="buttons-group">
              <router-link :to="currentSubItem.to" class="c-button c-button--lg">
                <div class="icon-w" style="font-size: 2.5em">
                  <div :class="currentSubItem.icon"></div>
                </div>
                <span style="font-size: 1.1em;" v-html="currentSubItem.description_hh || currentSubItem.description"> </span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="ae-labels">
          <div class="logged-user-w">
            <!-- La imagen apuntaba a http://localhost:8000 y se mostraba rota (ovalo vacio) -->
            <i class="fas fa-user-circle" style="font-size: 30px;"></i>
            <div class="logged-user-info-w">
              <div class="logged-user-name" v-html="user.name"></div>
              <div class="logged-user-role" v-html="user.email"></div>
            </div>
          </div>

          <a class="ae-label ae-label-red" href="#" @click.prevent="logout">
            <span class="label-pin"> </span>
            <span class="label-value">Cerrar Sesión</span>
            &nbsp
            <i class="fas fa-power-off"></i>
          </a>
          <!--a class="ae-label ae-label-green" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Personal</span>
          </a>
          <a class="ae-label ae-label-blue" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Statements</span>
          </a>
          <a class="ae-label ae-label-yellow" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Projects</span>
          </a-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      user: {
        name: "",
        image: "",
        email: "",
      },
      menuprincipal: true,
      sub_menu_name: "",
    };
  },
  props: {},
  watch: {
    "$route.query.modulo": function () {
      this.abrirModuloDeRuta();
    },
  },
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = "http://localhost:8000" + localStorage.getItem("image");
  },
  mounted() {
    this.abrirModuloDeRuta();
  },
  methods: {
    // Mismo cierre de sesion que el menu movil (AsideHHComponent)
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("tipo_usuario");
      localStorage.removeItem("secciones_permitidas");
      localStorage.removeItem("vistas_permitidas");
      localStorage.removeItem("ocultar_checklist_info");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    /**
     * ?modulo=<nombre> abre directamente el submenu de ese modulo (ej. al regresar
     * de cotizaciones moviles a POS o Inventario).
     */
    abrirModuloDeRuta() {
      const nombre = this.$route.query.modulo;
      if (!nombre) {
        return;
      }
      const modulo = (this.modules || []).find((item) => item.name === nombre && item.show_in_hh);
      if (modulo) {
        this.seleccionarMenu(modulo);
      }
    },
    regresar() {
      let self = this;
      self.sub_menu_name = "";
      self.menuprincipal = true;
    },
    toggleMenu() {
      $(".menu-mobile .menu-and-user").slideToggle(200, "swing");
    },
    seleccionarMenu(currentMenu) {
      let self = this;
      self.sub_menu_name = currentMenu.name;
      self.menuprincipal = false;
    },
  },
};
</script>

<style>
.c-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: inherit;
  display: inline-block;
  border: 0;
  border-radius: 0.3125em;
  background: #f2f2f2;
  border: solid 1px #ccc;
  color: rgb(94, 178, 40);
  padding: 0.625em 0.5em;
  font-size: 1rem;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  width: 100%;
  transition: 0.3s ease-out;
}

.c-button:hover {
  background: #fff;
}

.c-button:focus {
  outline: none;
  box-shadow: 0 0 0 4px #000;
}

.c-button svg {
  display: block;
  text-align: center;
  /*fill: #000;*/
  fill: rgb(94, 178, 40);
  width: 100%;
  height: 1.5em;
  margin-right: 0.25em;
}

.c-button--lg {
  font-size: 16px;
}

.buttons-group {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* Ocupa todo el alto de la columna (col-6 d-flex): todos los recuadros de la fila miden igual */
  flex: 1 1 auto;
}

.buttons-group > .c-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
}
</style>